module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres81x-index"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flgProcess),
      expression: "!flgProcess"
    }],
    staticClass: "animated fadeIn"
  }, [(_vm.msgError === '') ? [_c('div', {
    attrs: {
      "id": "index-detail"
    }
  }, [_c('div', {
    staticClass: "box-print clearfix"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-8 company-logo no-padding"
  }, [(typeof _vm.blockIndex.codcompny !== 'undefined' && _vm.blockIndex.codcompny !== '') ? _c('img', {
    attrs: {
      "src": _vm.baseUrl + 'file_uploads/Company_Logo/' + _vm.blockIndex.codcompny + '.png'
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.blockIndex.desc_codcompny))]), _vm._v(" "), (_vm.dispPrint) ? _c('div', {
    staticClass: "col-xs-6 col-md-4 printer",
    on: {
      "click": function($event) {
        _vm.togglePrint()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print Payslip")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse",
    attrs: {
      "data-widget": "collapse"
    },
    on: {
      "click": function($event) {
        _vm.toggleDetailBoxIndex()
      }
    }
  }, [_c('i', {
    class: 'icon-minus fa fa-' + [_vm.detailBoxIndexDisp ? 'minus' : 'plus']
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.blockIndex.codempid) + " - " + _vm._s(_vm.blockIndex.desc_codempid))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailBoxIndexDisp),
      expression: "detailBoxIndexDisp"
    }],
    staticClass: "box-body animated fadeIn"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left text-bold"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['15']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text-index detail"
  }, [_vm._v(_vm._s(_vm.blockIndex.position))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left text-bold"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['16']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text-index detail"
  }, [_vm._v(_vm._s(_vm.blockIndex.department))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left text-bold"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text-index detail"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.blockIndex.paymentdate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left text-bold"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text-index detail"
  }, [_vm._v(_vm._s(_vm.blockIndex.acc_id))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left text-bold"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['17']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text-index detail"
  }, [_vm._v(_vm._s(_vm.setDateRangeOutput(_vm.blockIndex.periodpy)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left text-bold"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['18']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text-index detail"
  }, [_vm._v(_vm._s(_vm.blockIndex.periodal))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse",
    attrs: {
      "data-widget": "collapse"
    },
    on: {
      "click": function($event) {
        _vm.toggleDetailBox1()
      }
    }
  }, [_c('i', {
    class: 'icon-minus fa fa-' + [_vm.detailBox1Disp ? 'minus' : 'plus']
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-bitcoin margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES81XCM']['245']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailBox1Disp),
      expression: "detailBox1Disp"
    }],
    staticClass: "box-body animated fadeIn"
  }, [_c('div', [_c('div', {
    staticClass: "text-header color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.block3.suminc) ? [_vm._l((_vm.block.amtinc), function(amtinc, index) {
    return [_c('div', {
      staticClass: "clearfix item-list"
    }, [_c('div', {
      staticClass: "pull-left panel-left text-detail"
    }, [_vm._v(_vm._s(_vm.block['codinc'][index]))]), _vm._v(" "), _c('div', {
      staticClass: "panel-right inline-block"
    }, [_c('div', {
      staticClass: "right-text"
    }, [_vm._v(_vm._s(amtinc) + " " + _vm._s(_vm.labels['HRES81XCM']['120']))])])])]
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix item-list"
  }, [_c('div', {
    staticClass: "txt-label pull-left panel-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['210']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text txt-label"
  }, [_vm._v(_vm._s(_vm.block3.suminc) + " " + _vm._s(_vm.labels['HRES81XCM']['120']))])])])] : _vm._e()], 2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-header color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.block3.sumpay) ? [_vm._l((_vm.block1.amtpay), function(amtpay, index) {
    return [_c('div', {
      staticClass: "clearfix item-list"
    }, [_c('div', {
      staticClass: "pull-left panel-left text-detail"
    }, [_vm._v(_vm._s(_vm.block1['codded'][index]))]), _vm._v(" "), _c('div', {
      staticClass: "panel-right inline-block"
    }, [_c('div', {
      staticClass: "right-text"
    }, [_vm._v(_vm._s(amtpay) + " " + _vm._s(_vm.labels['HRES81XCM']['120']))])])])]
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix item-list"
  }, [_c('div', {
    staticClass: "txt-label pull-left panel-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['220']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text txt-label"
  }, [_vm._v(_vm._s(_vm.block3.sumpay) + " " + _vm._s(_vm.labels['HRES81XCM']['120']))])])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailBox1Disp),
      expression: "detailBox1Disp"
    }],
    staticClass: "box-footer animated fadeIn"
  }, [_c('div', [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['245']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text"
  }, [_vm._v(_vm._s(_vm.block3.salary) + " " + _vm._s(_vm.labels['HRES81XCM']['120']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left"
  }, [_vm._v(_vm._s(_vm.labelsHres81x['net_pay_by_currency']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text"
  }, [_vm._v(_vm._s(_vm.block3.sumnet) + " " + _vm._s(_vm.labels['HRES81XCM']['120']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left"
  }, [_vm._v(_vm._s(_vm.labelsHres81x['net_pay']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text"
  }, [_vm._v(_vm._s(_vm.block3.sumnet_e) + " " + _vm._s(_vm.labels['HRES81XCM']['120']))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse",
    attrs: {
      "data-widget": "collapse"
    },
    on: {
      "click": function($event) {
        _vm.toggleDetailBox2()
      }
    }
  }, [_c('i', {
    class: 'icon-minus fa fa-' + [_vm.detailBox2Disp ? 'minus' : 'plus']
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-info-circle margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES81XCM']['130']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailBox2Disp),
      expression: "detailBox2Disp"
    }],
    staticClass: "box-body animated fadeIn"
  }, [(_vm.block2.qtysmot) ? [_vm._l((_vm.block2.qtysmot), function(qtysmot, index) {
    return [(qtysmot != ':') ? [_c('div', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "pull-left panel-left"
    }, [_vm._v("\n                      " + _vm._s(_vm.block2['desot'][index]) + " " + _vm._s(_vm.block2['rteot'][index]) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "panel-right inline-block"
    }, [_c('div', {
      staticClass: "right-text detail"
    }, [_vm._v("\n                        " + _vm._s(_vm.block2['qtysmot'][index]) + " " + _vm._s(_vm.block2['hrs'][index]) + "\n                      ")])])])] : _vm._e()]
  }), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text detail"
  }, [_vm._v(_vm._s(_vm.block3.vacation) + " " + _vm._s(_vm.labels['HRES81XCM']['270']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text detail"
  }, [_vm._v(_vm._s(_vm.block3.qtywrk) + " " + _vm._s(_vm.labels['HRES81XCM']['270']))])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse",
    attrs: {
      "data-widget": "collapse"
    },
    on: {
      "click": function($event) {
        _vm.toggleDetailBox3()
      }
    }
  }, [_c('i', {
    class: 'icon-minus fa fa-' + [_vm.detailBox3Disp ? 'minus' : 'plus']
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-line-chart margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES81XCM']['160']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailBox3Disp),
      expression: "detailBox3Disp"
    }],
    staticClass: "box-body animated fadeIn"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text detail"
  }, [_vm._v(_vm._s(_vm.block3.amtcalt) + " " + _vm._s(_vm.labels['HRES81XCM']['120']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['180']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text detail"
  }, [_vm._v(_vm._s(_vm.block3.amttax) + " " + _vm._s(_vm.labels['HRES81XCM']['120']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['190']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text detail"
  }, [_vm._v(_vm._s(_vm.block3.amtsoc) + " " + _vm._s(_vm.labels['HRES81XCM']['120']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left panel-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES81XCM']['200']))]), _vm._v(" "), _c('div', {
    staticClass: "panel-right inline-block"
  }, [_c('div', {
    staticClass: "right-text detail"
  }, [_vm._v(_vm._s(_vm.block3.amtpf) + " " + _vm._s(_vm.labels['HRES81XCM']['120']))])])])])])])] : [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-info-circle margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labelsHres81x['no_data_found']))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {}, [_vm._v(_vm._s(_vm.msgError))])])])]], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flgProcess),
      expression: "flgProcess"
    }],
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "loader center"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b91a283!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres81x/index.vue
// module id = 3835
// module chunks = 1